import { useAuthInfo, webURI } from "../../common";

export function useSampleRequestPageLink(sampleRequestID) {
  const decoded = useAuthInfo();
  return `${webURI}/${
    decoded.role === "procurement" ? "procurementApproval" : "requestDetails"
  }/${sampleRequestID}`;
}
